import axios from "axios";
import errorHandler from "./errorHandler";

const headers = {};

const api = axios.create({
  baseURL: process.env.VUE_APP_EG_API_URL,
  headers,
});

// successHandler just returns normal response from server
const successHandler = (res) => res;

api.interceptors.response.use(successHandler, errorHandler);

export default api;
